import { emptyObj } from 'util/objects'
import { createBasicSelector } from 'util/redux'
import { selectCurrentQueryId } from './selectCurrentQueryId'
import { queryIdToQuery } from '../utils/query'

export const selectCurrentQuery = createBasicSelector(
  selectCurrentQueryId,
  queryId => queryIdToQuery(queryId) || emptyObj
)
